module.exports = __webpack_public_path__ + "img/indigent2_7-8-2021.36e6376b.jpg";